import { render, staticRenderFns } from "./CampusStatistics.vue?vue&type=template&id=318dbec5&"
import script from "./CampusStatistics.vue?vue&type=script&lang=js&"
export * from "./CampusStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CampusStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports